module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"goToJournal":"Go to Journal","seeMoreInsights":"See more Insights","weeklyPeriod":"Weekly Summary"},"es":{"goToJournal":"Ir a la Bitácora","seeMoreInsights":"Ver mas Insights","weeklyPeriod":"Resumen Semanal"}}')
  delete Component.options._Ctor
}
